import { Button, Col, Form, Row, Select, Typography } from "antd";
import { useMutation, useQuery } from "../hooks";
import { useAuth } from "../providers";

import { SaveOutlined } from "@ant-design/icons";
import { Input, notification } from "antd";
import {
  ContainerComponent,
  FileUploaderComponent,
  MarkDownEditorComponent,
} from "../components";
import ImageUploader from "../components/image-uploader";
import "../presentation/workshops/css/workshops.css";
import { InvolvedAgentsPartial } from "./involved-agents.partial";
import { MetricsWorkshop } from "./metrics-workshop.partial";


export const WorkShopFormPartial = ({ initialValues, method, onSave }) => {
  const [api, contextHolder] = notification.useNotification()
  const { user } = useAuth();
  const [form] = Form.useForm();
  const demoUrlValue = Form.useWatch("demoUrl", form);
  const normalizedDemoUrl = (values) =>
    values?.demoUrl?.trim() || values?.demoURL?.trim() || values?.videoUrl?.trim() || null;
  const { data: categories, loading: loadingCategories } = useQuery({
    url: `/category`,
    options: { method: "GET" },
  });

  const { loading, executeMutation } = useMutation({
    url: `/workshop`,
    method: method,
    onSuccess: (data) => {
      onSave(data);
      form.resetFields();
    },
  });

  const onFinish = async () => {
    //form.setFieldsValue({ metrics: form.getFieldValue("metrics") });
    const values = await form.validateFields();

    const payload = {
      id: values.id,
      title: values.title,
      description: values.description,
      actualKnowledge: values.actualKnowledge,
      knowledgeImg: values.knowledgeImg,
      metrics: values?.metricsBefore || values?.metrics || [],
      metricsBefore: values?.metricsBefore || values?.metrics || [],
      metricsAfter: values?.metricsAfter || [],
      volumetry: values.volumetry,
      agentObjective: values.agentObjective,
      architecture: values.architecture,
      dataSources: values.dataSources,
      filesUrl: values.filesUrl,
      prompt: values.prompt,
      problemSteps: values.problemSteps,
      functionalDiagramUrl: values.functionalDiagramUrl,
      functionalLogicDiagramUrl: values.functionalLogicDiagramUrl,
      agentsSequenceDiagramUrl: values.agentsSequenceDiagramUrl,
      agents: values?.agents || [],
      status: values.status,
      hashTags: values.hashTags,
      idUser: method === "POST" ? user.id : initialValues.idUser,
      idIndustry: values.idIndustry,
      idTypology: values.idTypology,
      demoUrl: normalizedDemoUrl(values),
      demoURL: normalizedDemoUrl(values),
      videoUrl: normalizedDemoUrl(values),
    };

    console.log({ payload });
    //console.log(JSON.stringify(payload));
    executeMutation({ ...payload });
  };

  const onFinishFailed = ({ errorFields }) => {
    api.warning({
      message: "Campos incompletos",
      description: "Por favor, completa todos los campos requeridos antes de guardar.",
      placement: "topRight",
      className: "custom-notification-bg",
      duration: 3,
    });
    if (errorFields && errorFields.length > 0) {
      form.scrollToField(errorFields[0].name);
    }
  }


  return (
    <>
      {contextHolder}
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{
          ...initialValues,
          id: initialValues?.id,
          metrics: initialValues?.metrics,
          metricsBefore:
            initialValues?.metricsBefore ?? initialValues?.metrics ?? [],
          metricsAfter: initialValues?.metricsAfter ?? [],
          status: initialValues?.status || "pending",
          agents: initialValues?.agents || [],
          idUser: initialValues?.idUser || user.id,
          demoUrl: initialValues?.demoUrl || initialValues?.demoURL || initialValues?.videoUrl || "",
        }}
      >
        <ContainerComponent
          style={{
            backgroundColor: "#ffffff",
            padding: 24,
            borderRadius: 16,
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
            marginBottom: 24,
          }}
        >
          <Row>
            <Col span={24}>
              <Typography.Title style={{ textAlign: "left" }} level={3}>
                Taller Interactivo
              </Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: "left", marginBottom: 16 }}>
              <Typography.Text style={{ color: "#969696" }}>
                Defina un nuevo taller interactivo especificando los detalles de
                su negocio y el problema a resolver, su solución de agentes, será
                creada en base a los datos proporcionados.
              </Typography.Text>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="id"
                style={{ display: "none" }}
                rules={[{ required: false, message: "Requerido" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="title"
                label="Título del Proyecto"
                rules={[{ required: true, message: "Requerido" }]}
              >
                <Input
                  name="title"
                  placeholder="Ej: Automatización de procesos de ventas"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="start" align="stretch">
            <Col span={12}>
              <Form.Item
                name={"idIndustry"}
                label={"Categoría"}
                style={{ marginBottom: 8, width: "100%" }}
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.reject(
                          "Debe seleccionar al menos una categoría"
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Seleccione una categoría"
                  loading={loadingCategories}
                  allowClear
                  filterOption={(input, option) =>
                    option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onSelect={(value) => form.setFieldsValue({ idIndustry: value })}
                  onDeselect={() => form.setFieldsValue({ idIndustry: null })}
                  options={
                    categories?.map((industry) => ({
                      value: industry.id,
                      label: industry.name,
                    })) || []
                  }
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="status"
                label="Estado de construcción"
                rules={[{ required: true, message: "Requerido" }]}
                style={{ width: "100%" }}
              >
                <Select
                  defaultValue={"pending"}
                  placeholder="Agrega los agentes (ejemplo: CRM, Marketing, Venta, etc.)"
                  style={{ width: "100%" }}
                  options={[
                    { value: "pending", label: "Pendiente" },
                    { value: "on_progress", label: "En proceso" },
                    { value: "completed", label: "Completado" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="start" align="stretch">
            <Col span={24}>
              <Form.Item
                name="description"
                label='Descripción del problema "As Is"'
                rules={[{ required: true, message: "Requerido" }]}
              >
                <MarkDownEditorComponent
                  key={"description"}
                  name="description"
                  initialValue={form.getFieldValue("description")}
                  placeHolder="Describa el problema actual que desea resolver..."
                  onChange={(value) =>
                    form.setFieldsValue({ description: value.value })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item
            name="metricsBefore"
            label="Métricas Antes"
            rules={[
              {
                required: true,
                message: "Requerido, debe contener al menos una métrica",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || value.length === 0) {
                    return Promise.reject("Debe agregar al menos una métrica");
                  }
                  // Verifica que todos los campos de cada métrica tengan contenido
                  const vacio = value.some(
                    (item) =>
                      !item.metric?.trim() ||
                      !item.description?.trim() ||
                      !item.volume?.trim()
                  );
                  if (vacio) {
                    return Promise.reject(
                      "Todos los campos de cada métrica son obligatorios"
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <MetricsWorkshop addLabel="Agregar métrica antes" />
          </Form.Item>
          <Form.Item
            name="metricsAfter"
            label="Métricas Después"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || value.length === 0) {
                    return Promise.resolve();
                  }
                  const vacio = value.some(
                    (item) =>
                      !item.metric?.trim() ||
                      !item.description?.trim() ||
                      !item.volume?.trim()
                  );
                  if (vacio) {
                    return Promise.reject(
                      "Todos los campos de cada métrica son obligatorios"
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <MetricsWorkshop showVariation addLabel="Agregar métrica después" />
          </Form.Item>
          <Row>
            <Col span={24}>
              <Form.Item
                name="dataSources"
                label="Fuentes de Datos"
                rules={[{ required: true, message: "Requerido" }]}
              >
                <Select
                  mode="tags"
                  placeholder="Agrega las fuentes de datos (ejemplo: Sensores, CRM, APIs Rest, Base de datos, etc.)"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="start" align="stretch">
            <Col span={16}>
              <Form.Item
                name="actualKnowledge"
                label="Conocimiento Técnico Actual"
                style={{
                  flexGrow: 1,
                  flexBasis: "100%",
                }}
              >
                <MarkDownEditorComponent
                  key={"actualKnowledge"}
                  name="actualKnowledge"
                  initialValue={form.getFieldValue("actualKnowledge")}
                  placeHolder="Describa el conocimiento técnico actual..."
                  onChange={(value) =>
                    form.setFieldsValue({ actualKnowledge: value.value })
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="knowledgeImg" label="Imagen del sistema actual">
                <ImageUploader
                  initialValue={initialValues?.knowledgeImg}
                  onSaved={(imageUrl) =>
                    form.setFieldsValue({ knowledgeImg: imageUrl })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </ContainerComponent>
        <ContainerComponent
          style={{
            padding: 24,
            marginBottom: 24,
            backgroundColor: "#ffffff",
            borderRadius: 16,
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
          }}
        >
          {initialValues?.id && (
            <Form.Item name="agents">
              <InvolvedAgentsPartial
                initialAgents={initialValues?.agents}
                onChangeAgents={(agents) => {
                  form.setFieldsValue({
                    agents: agents.map(({ key, label, ...rest }) => rest),
                  });
                }}
              />
            </Form.Item>
          )}
        </ContainerComponent>

        <ContainerComponent
          style={{
            backgroundColor: "#ffffff",
            padding: 24,
            borderRadius: 16,
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
            marginBottom: 24,
          }}
        >
          <Row>
            <Col span={24}>
              <Typography.Title style={{ textAlign: "left" }} level={4}>
                Información adicional
              </Typography.Title>
            </Col>
            <Col span={24}>
              <Typography.Title style={{ textAlign: "left" }} level={5}>
                Documentos de referencia
              </Typography.Title>
            </Col>
          </Row>
          <Form.Item name="filesUrl">
            <FileUploaderComponent
              initialValues={initialValues?.filesUrl}
              onFileUploaded={(urlFiles) => {
                form.setFieldsValue({ filesUrl: urlFiles });
              }}
            />
          </Form.Item>
          <Row>
            <Col span={24}>
              <Typography.Title
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#969696",
                }}
              >
                solo archivos .docx, xlsx y pdf permitidos
              </Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name="architecture" label="Arquitectura actual">
                <Input placeholder="Ej: Azure: App Service, Azure Functions, Cosmos DB, Azure AI" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="agentObjective"
                label="Objetivo de implementar Agentes"
              >
                <MarkDownEditorComponent
                  key={"agentObjective"}
                  name="agentObjective"
                  initialValue={form.getFieldValue("agentObjective")}
                  placeHolder="Ej: Reducir el tiempo de mantenimiento correctivo y aumentar la tasa de conversión."
                  onChange={(value) =>
                    form.setFieldsValue({ agentObjective: value.value })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {initialValues?.id && (
                <Form.Item name="prompt" label="Prompt">
                  <MarkDownEditorComponent
                    key={"prompt"}
                    name="prompt"
                    initialValue={form.getFieldValue("prompt")}
                    placeHolder="Prompt"
                    onChange={(value) =>
                      form.setFieldsValue({ prompt: value.value })
                    }
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              {initialValues?.id && (
                <Form.Item
                  name="problemSteps"
                  label="Pasos para resolver el problema"
                >
                  <MarkDownEditorComponent
                    key={"problemSteps"}
                    name="problemSteps"
                    initialValue={form.getFieldValue("problemSteps")}
                    placeholder="Ej. Paso 1: Maquina se calienta. Paso 2: El sensor de temperatura dispara una alerta... Paso 3: El alerta se envia la alerta a la central de control."
                    onChange={(value) =>
                      form.setFieldsValue({ problemSteps: value.value })
                    }
                  />
                </Form.Item>
              )}
            </Col>
          </Row>
          {initialValues?.id && (
            <Row gutter={[16, 16]} justify="start" align="stretch">
              <Col span={8}>
                <Form.Item name="functionalDiagramUrl" label="Diagrama funcional">
                  <ImageUploader
                    initialValue={initialValues?.functionalDiagramUrl}
                    style={{ width: "100%" }}
                    onSaved={(imageUrl) =>
                      form.setFieldsValue({ functionalDiagramUrl: imageUrl })
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="functionalLogicDiagramUrl"
                  label="Diagrama lógico funcional"
                >
                  <ImageUploader
                    initialValue={initialValues?.functionalLogicDiagramUrl}
                    style={{ width: "100%" }}
                    onSaved={(imageUrl) =>
                      form.setFieldsValue({ functionalLogicDiagramUrl: imageUrl })
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="agentsSequenceDiagramUrl"
                  label="Secuencia de Agentes"
                >
                  <ImageUploader
                    initialValue={initialValues?.agentsSequenceDiagramUrl}
                    style={{ width: "100%" }}
                    onSaved={(imageUrl) =>
                      form.setFieldsValue({ agentsSequenceDiagramUrl: imageUrl })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row gutter={[16, 16]} justify="start" align="stretch">
            <Col span={12}>
              <Form.Item
                name="hashTags"
                label="Hashtags"
                style={{ width: "100%" }}
              >
                <Select
                  mode="tags"
                  placeholder="Agrega los agentes (ejemplo: CRM, Marketing, Venta, etc.)"
                  onChange={(value) => form.setFieldsValue({ hashTags: value })}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name={"demoUrl"}
                label="URL del video (opcional)"
                style={{ marginBottom: 8, width: "100%" }}
                rules={[{ type: "url", message: "Ingresa una URL válida" }]}
              >
                <Input
                  name="demoUrl"
                  placeholder="https://..."
                />
              </Form.Item>
              <Form.Item style={{ marginBottom: 12 }}>
                <Button
                  danger
                  onClick={() => form.setFieldsValue({ demoUrl: "" })}
                  disabled={!String(demoUrlValue || "").trim()}
                >
                  Quitar video
                </Button>
              </Form.Item>
              <Form.Item label="Subir video (opcional)" style={{ marginBottom: 8 }}>
                <FileUploaderComponent
                  initialValues={
                    demoUrlValue
                      ? [demoUrlValue]
                      : []
                  }
                  accept="video/*"
                  multiple={false}
                  maxFileSizeMB={25}
                  onFileUploaded={(urlFiles) => {
                    const uploadedVideoUrl = urlFiles?.[0] || "";
                    form.setFieldsValue({ demoUrl: uploadedVideoUrl });
                  }}
                />
              </Form.Item>
              <Typography.Text style={{ color: "#969696", display: "block", marginBottom: 8 }}>
                Puedes subir MP4/MOV/WEBM (máx. 25MB). Si falla, usa URL del video.
              </Typography.Text>
            </Col>
          </Row>
        </ContainerComponent>

        {/* <ContainerComponent
          style={{
            backgroundColor: "#ffffff",
            padding: "16px 16px 0 0",
            borderRadius: 16,
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
            marginBottom: 24,
          }}
        >
          <Row>
            <Col span={24}>
              <Form.Item style={{ textAlign: "end" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  loading={loading}
                  style={{ marginRight: 8, backgroundColor: "var(--color-secondary)" }}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </ContainerComponent> */}
      </Form>
      <Button
        type="primary"
        htmlType="submit"
        size="large"
        loading={loading}
        style={{
          position: "fixed",
          bottom: 32,
          right: 32,
          zIndex: 2000,
          backgroundColor: "var(--color-secondary)",
          boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
        }}
        onClick={() => form.submit()}
      >
        <SaveOutlined />
        {method === "PUT" ? "Actualizar" : "Guardar"}
      </Button>
    </>
  );
};
